import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { FooterComponent } from './footer/footer.component';
import { PrivacyDocumentationComponent } from './privacy-documentation/privacy-documentation.component';
import { PersonalInfoFormComponent } from './personal-info-form/personal-info-form.component';
import { AgreementSignatureComponent } from './agreement-signature/agreement-signature.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PrivacyAboutComponent } from './privacy-about/privacy-about.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { MainComponent } from './main/main.component';
import { EmailsMonitoringComponent } from './emails-monitoring/emails-monitoring.component';
import { BlogComponent } from './blog/blog.component';
import { BlogInfoComponent } from './blog-info/blog-info.component';
import { PricingComponent } from './pricing/pricing.component';
import { BuyNowComponent } from './buy-now/buy-now.component';
import { LandingBuyNowComponent } from './landing-buy-now/landing-buy-now.component';
import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';
import { LandingMainComponent } from './landing-main/landing-main.component';
import { LandingPricingComponent } from './landing-pricing/landing-pricing.component';
import { LangingBuyNowGybComponent } from './langing-buy-now-gyb/langing-buy-now-gyb.component';
import { FaqComponent } from './faq/faq.component';

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { BuyNowLongTermComponent } from './buy-now-long-term/buy-now-long-term.component';
import { BuyNowLongTermHiComponent } from './buy-now-long-term-hi/buy-now-long-term-hi.component';
import { LivechatWidgetComponent } from './livechat-widget/livechat-widget.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    LoginComponent,
    ProfileComponent,
    SubscriptionsComponent,
    FooterComponent,
    PrivacyDocumentationComponent,
    PersonalInfoFormComponent,
    AgreementSignatureComponent,
    DashboardComponent,
    PrivacyAboutComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    MainComponent,
    EmailsMonitoringComponent,
    BlogComponent,
    BlogInfoComponent,
    PricingComponent,
    BuyNowComponent,
    LandingBuyNowComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    LandingMainComponent,
    LandingPricingComponent,
    LangingBuyNowGybComponent,
    FaqComponent,
    BuyNowLongTermComponent,
    BuyNowLongTermHiComponent,
    LivechatWidgetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en'
    }),
    SharedModule
  ],
  providers: [
    provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    })
  ],
    exports: [
        HeaderComponent,
        FooterComponent
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
